import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import $ from 'jquery';
import 'slick-carousel';
import SingleDay from './SingleDay';

const Calendar = () => {
    // Mejor usar objeto que ya traiga arrayDays vacío
    const [config, setConfig] = useState({ arrayDays: [] });
    const { arrayDays: days } = config;

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Listener de resize + cleanup
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Carga de configuración + slick
    useEffect(() => {
        let slidesToShowCal = 3;

        if (typeof all_rooms !== 'undefined' && all_rooms) {
            slidesToShowCal = 2;
        }
        if (windowWidth <= 800) {
            slidesToShowCal = 1;
        }

        const getConfig = async () => {
            try {
                let url;

                if (typeof all_rooms !== 'undefined' && all_rooms) {
                    url = `/admin/enfermera/agenda-extra-config/`;
                } else {
                    url = `/admin/panel-therapies/${internal_room}/config`;
                }

                const resp = await fetch(url);
                const data = await resp.json();

                setConfig(data);

                // Esperamos un tick para que React pinte <SingleDay />
                setTimeout(() => {
                    if ($('.wrap-days').hasClass('slick-initialized')) {
                        $('.wrap-days').slick('unslick');
                    }

                    $('.wrap-days').slick({
                        slidesToShow: slidesToShowCal,
                        infinite: false,
                        initialSlide: getInitialSlide(data.arrayDays || []),
                        swipe: true,
                        draggable: true,
                        touchMove: true,
                    });
                }, 0);
            } catch (e) {
                console.log(e);
            }
        };

        getConfig();
    }, [windowWidth]); // si redimensionas muuuucho podrías limitar esto, pero funciona

    const getInitialSlide = (days) => {
        let initial = 0;
        (days || []).forEach((item, index) => {
            if (item.today) {
                initial = index;
            }
        });
        return initial;
    };

    return (
        <div className="wrap-days">
            {days && days.map((d, index) => (
                <SingleDay
                    key={`day-${index}`}
                    day={d}
                    config={config}
                    setConfig={setConfig}
                />
            ))}
        </div>
    );
};

// ==== React 18: createRoot en lugar de ReactDOM.render ====
const el = document.getElementById('calendar');

if (el) {
    const root = createRoot(el);
    root.render(<Calendar />);
}
